import { AppConfig } from 'app/model/app-config';
import { RestfulApiService } from 'app/services/restful-api.service';

class AppConfigService extends RestfulApiService<AppConfig> {
    protected getFormName(): string {
        return 'app_config';
    }

    protected getPath(): string {
        return 'configs';
    }
}

export const appConfigService = new AppConfigService();
